import { ParsedErrorResponse } from 'types/fetch';
import { IssuerStepupErrorCode } from 'types/visa-sdk/authenticate';

export async function getAuthenticateErrorMapping(
  response: ParsedErrorResponse<ParsedErrorResponse>
) {
  switch (response.errorCode as IssuerStepupErrorCode) {
    // 400 - cvmNotAvailable
    case 1160: {
      return {
        errorCode: 'AUTHENTICATION_METHOD_NOT_SUPPORTED',
        errorMessage: response.errorMessage
      };
    }
    // 409 - notAllowed (Threshold met)
    case 1165: {
      return {
        errorCode: 'RETRIES_EXCEEDED',
        errorMessage: response.errorMessage
      };
    }
    // 409 - expired
    case 1164: {
      return {
        errorCode: 'VAL_DATA_EXPIRED',
        errorMessage: response.errorMessage
      };
    }
    // 400 - valDataInvalid (Wallet service error)
    case 1161: {
      return {
        errorCode: 'VAL_DATA_INVALID',
        errorMessage: response.errorMessage
      };
    }

    default:
      return {
        errorCode: 'AUTHENTICATE_FAILURE',
        errorMessage: response.errorMessage
      };
  }
}
